import {CardEnum, GameEventHistory, PlayerColor} from '@colonist/game-states'
import {VictoryPointDataController, VictoryPointStateReader, VictoryPointTypes} from '@colonist/game-base-types'
import {ReplayHighlightData, ReplayHighlightType} from './elements/UIReplaySliderHighlight'
import {applyDiffs} from '@colonist/game-state-types'

export function getHighlightsFromEventHistory(eventHistory: GameEventHistory): ReplayHighlightData[] {
    let highlights: ReplayHighlightData[] = []
    highlights = highlights
        .concat(getMonopolyHighlights(eventHistory))
        .concat(getLongestRoadLargestArmyHighlights(eventHistory))
        .concat(getManyPointsHighlights(eventHistory, 4))

    return highlights
}

function getMonopolyHighlights(eventHistory: GameEventHistory): ReplayHighlightData[] {
    const highlights: ReplayHighlightData[] = []

    for(let actionIndex = 0; actionIndex < eventHistory.events.length; actionIndex++) {
        const event = eventHistory.events[actionIndex]
        for(const key in event.stateChange.mechanicDevelopmentCardsState?.players) {
            const playerColor = Number(key) as PlayerColor
            const devCardState = event.stateChange.mechanicDevelopmentCardsState?.players[playerColor]

            if(devCardState == undefined) continue
            if(devCardState.developmentCardsUsed == undefined) continue
            if(devCardState.developmentCardsUsed[devCardState.developmentCardsUsed.length - 1] != CardEnum.Monopoly) continue

            highlights.push({actionIndex: actionIndex, type: ReplayHighlightType.MonopolyPlayed})
        }
    }

    return highlights
}

function getLongestRoadLargestArmyHighlights(eventHistory: GameEventHistory): ReplayHighlightData[] {
    const highlights: ReplayHighlightData[] = []

    let largestArmyGotForLastTimeAt: number | undefined
    let longestRoadGotForLastTimeAt: number | undefined

    for(let actionIndex = 0; actionIndex < eventHistory.events.length; actionIndex++) {
        const event = eventHistory.events[actionIndex]
        for(const key in event.stateChange.playerStates) {
            const playerColor = Number(key) as PlayerColor
            const playerState = event.stateChange.playerStates[playerColor]
            if(playerState == undefined) continue

            if(playerState.victoryPointsState == undefined) continue

            for(const victoryPointType of Object.keys(playerState.victoryPointsState)) {
                const victoryPointData = VictoryPointDataController.getVictoryPointByType(Number(victoryPointType))
                if(victoryPointData?.victoryPointType == VictoryPointTypes.LargestArmy) largestArmyGotForLastTimeAt = actionIndex
                if(victoryPointData?.victoryPointType == VictoryPointTypes.LongestRoad) longestRoadGotForLastTimeAt = actionIndex
            }
        }
    }

    if(largestArmyGotForLastTimeAt != undefined) highlights.push({actionIndex: largestArmyGotForLastTimeAt, type: ReplayHighlightType.LargestArmy})
    if(longestRoadGotForLastTimeAt != undefined) highlights.push({actionIndex: longestRoadGotForLastTimeAt, type: ReplayHighlightType.LongestRoad})

    return highlights
}

function getManyPointsHighlights(eventHistory: GameEventHistory, minPointsInclusive: number): ReplayHighlightData[] {
    const highlights: ReplayHighlightData[] = []
    const gameStateClone = structuredClone(eventHistory.initialState)

    const pointsAtStartOfTurn: Map<PlayerColor, number> = new Map()
    for(const player in eventHistory.initialState.playerStates) {
        const playerColor = Number(player) as PlayerColor
        const playerState = eventHistory.initialState.playerStates[playerColor]
        if(playerState == undefined) continue

        pointsAtStartOfTurn.set(playerColor, VictoryPointStateReader.totalPublicVictoryPoints(playerState.victoryPointsState))
    }

    let firsActionIndexOfThisTurn: number = 0
    for(const [index, event] of eventHistory.events.entries()) {
        const isEndOfTurn = event.stateChange.currentState?.completedTurns != undefined
        const isLastAction = index == eventHistory.events.length - 1
        if(isEndOfTurn || isLastAction) {
            for(const player in gameStateClone.playerStates) {
                const playerColor = Number(player) as PlayerColor
                const playerState = gameStateClone.playerStates[playerColor]
                if(playerState == undefined) continue
                const pointsAtEndOfTurn = VictoryPointStateReader.totalPublicVictoryPoints(playerState.victoryPointsState)

                const vpsObtainedThisTurn = pointsAtEndOfTurn - (pointsAtStartOfTurn.get(playerColor) ?? 0)
                if(vpsObtainedThisTurn >= minPointsInclusive) highlights.push({actionIndex: firsActionIndexOfThisTurn, type: ReplayHighlightType.ManyPointsInOneTurn})

                pointsAtStartOfTurn.set(playerColor, pointsAtEndOfTurn)
            }

            firsActionIndexOfThisTurn = index + 1
        }

        applyDiffs(gameStateClone, [event.stateChange])
    }

    return highlights
}
